"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.memoize = exports.retryOnError = void 0;
const Logger_1 = require("./Logger");
const RETRY_ATTEMPTS = 25;
const RETRY_DELAY = 1000;
const retryOnError = ({ callback, times = RETRY_ATTEMPTS, retryDelay = RETRY_DELAY, retriesCount = 0, label = '', }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const result = yield callback();
        return result;
    }
    catch (error) {
        if (retriesCount < times) {
            Logger_1.logger.warn(`Function call "${label}" failed. Retry: ${retriesCount + 1}.`);
            yield new Promise((res) => setTimeout(res, retryDelay));
            return (0, exports.retryOnError)({
                callback,
                times,
                retriesCount: retriesCount + 1,
                retryDelay,
                label,
            });
        }
        Logger_1.logger.info(`Failed to execute function in: ${times} attempts`);
        throw error;
    }
});
exports.retryOnError = retryOnError;
const memoize = (func) => {
    const cache = {};
    return (...args) => __awaiter(void 0, void 0, void 0, function* () {
        const key = JSON.stringify(args);
        if (!Object.keys(cache).includes(key)) {
            cache[key] = yield (0, exports.retryOnError)({ callback: () => func(...args) });
        }
        return cache[key];
    });
};
exports.memoize = memoize;
